import {
  type ExtractPayload,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { loadSlide, toggleLegend } from 'presentation/viewPane/actions';
import {
  settleLegendOnSlide,
  DEFAULT_SLIDE_LEGEND_STATE,
  setSlideLegend,
  type SlideLegendState,
} from './slideLegend';

const handleLoadSlide = (
  state: SlideLegendState,
  { id }: ExtractPayload<typeof loadSlide>
): SlideLegendState => settleLegendOnSlide(state, id);

const handleToggleLegend = (
  state: SlideLegendState,
  { legendActive }: ExtractPayload<typeof toggleLegend>
): SlideLegendState => setSlideLegend(state, legendActive);

export const slideLegend$ = persistentReducedStream(
  'slideLegend$',
  DEFAULT_SLIDE_LEGEND_STATE,
  [
    reducer(loadSlide, handleLoadSlide),
    reducer(toggleLegend, handleToggleLegend),
  ]
);

export const legendActive$: Observable<boolean> = slideLegend$.pipe(
  map(({ legendActive }) => legendActive),
  distinctUntilChanged()
);
